// Guards against `javascript:`/`data:`/`vbscript:` URLs sneaking into an href or
// window.open target. User-supplied URLs (KB links, file/link entries, vault
// sites) are rendered as clickable links, so an unvalidated `javascript:...`
// value would execute script in the victim's session on click (stored XSS).
//
// Returns a safe, navigable URL, or "" when the input can't be made safe.
// Allowed: http(s), mailto, tel, and site-relative paths ("/foo", "foo/bar").

const SAFE_ABSOLUTE_SCHEME = /^(https?|mailto|tel):/i;
// Anything of the form "scheme:" that isn't in the allow-list above is rejected.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function safeUrl(url) {
  if (typeof url !== "string") return "";
  // Strip whitespace/tab/newline an attacker can use to break the scheme check
  // (e.g. "java\tscript:alert(1)" — browsers ignore the tab, our regex wouldn't).
  const trimmed = url.trim().replace(/[\t\n\r\f\v]/g, "");
  if (!trimmed) return "";

  if (SAFE_ABSOLUTE_SCHEME.test(trimmed)) return trimmed;

  // Reject any other explicit scheme (javascript:, data:, vbscript:, file:, …).
  if (HAS_SCHEME.test(trimmed)) return "";

  // No scheme → treat as a relative/site path, which is safe to navigate to.
  return trimmed;
}

export default safeUrl;
